module.exports = __webpack_public_path__ + "static/img/news6.90765b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/news6.png
// module id = DjU3
// module chunks = 52